import { Component, OnInit } from '@angular/core';
import {AbstractConfirmComponent} from "../abstractconfirm";
import {ModalService} from "../service";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  template: `
    <ng-template #modalHeader>
      <div class="title__content">
        <icon name="warning" size="25"></icon><span [innerHTML]="title"></span>
      </div>
    </ng-template>
    <ng-template #modalBody>
      <div class="content" [innerHTML]="content"></div>
    </ng-template>
    <ng-template #modalActions>
      <lk-modal-footer [actions]="actions"></lk-modal-footer>
    </ng-template>
  `,
  styles: [
    `.title__content {display: flex; align-items: center; line-height:1px}`,
    `.content {padding: 0 20px;}`,
    `a {text-decoration: underline; color: #0081E3}`,
    `icon {margin-right: 5px}`
  ]
})
export class ModalConfirmComponent extends AbstractConfirmComponent implements OnInit {

  constructor(
    private _sanitizer: DomSanitizer,
    protected _modal: ModalService
  ) {
    super(_modal);
  }

  ngOnInit() {
    this.title = this._sanitizer.bypassSecurityTrustHtml(this.title as string);
    this.content = this._sanitizer.bypassSecurityTrustHtml(this.content as string);
  }


}
